<div class="registration">
  <div class="registration__container">
    <form
      class="registration__form"
      [formGroup]="registrationForm"
      (ngSubmit)="onSubmit()"
      novalidate
    >
      <img alt="menu logo" src="{{ LOGO }}" class="img__logo" />
      <h3 class="main-title left-aligned">Registracija naloga</h3>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon': getRegisterForm.name.errors && getRegisterForm.name.touched,
              'is-valid-icon': getRegisterForm.name.valid && getRegisterForm.name.touched,
              'input-focus': isNameInputFocused && !getRegisterForm.name.touched
            }"
          >
            <img src="{{ USER }}" alt="" />
          </div>
          <input
            id="name"
            type="text"
            placeholder="Unesite ime"
            required
            formControlName="name"
            autocomplete="on"
            class="form-control"
            (input)="inputChanged($event)"
            [ngClass]="{
              'is-invalid': getRegisterForm.name.errors && getRegisterForm.name.touched
            }"
            [class.is-valid]="getRegisterForm.name.valid && getRegisterForm.name.touched"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isNameInputFocused = true"
            (blur)="isNameInputFocused = false"
          />

          @if (getRegisterForm.name.errors && getRegisterForm.name.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.name.errors.required) {
                <div id="name_mandatory">Ime je obavezno!</div>
              }
              @if (getRegisterForm.name.errors.pattern) {
                <div id=" name_validator">Unos nije validan!</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon': getRegisterForm.surname.errors && getRegisterForm.surname.touched,
              'is-valid-icon': getRegisterForm.surname.valid && getRegisterForm.surname.touched,
              'input-focus': isSurnameInputFocused && !getRegisterForm.surname.touched
            }"
          >
            <img src="{{ USER }}" alt="" />
          </div>
          <input
            id="surname"
            type="text"
            placeholder="Unesite prezime"
            required
            autocomplete="on"
            formControlName="surname"
            class="form-control"
            (input)="inputChanged($event)"
            [ngClass]="{
              'is-invalid': getRegisterForm.surname.errors && getRegisterForm.surname.touched
            }"
            [class.is-valid]="getRegisterForm.surname.valid && getRegisterForm.surname.touched"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isSurnameInputFocused = true"
            (blur)="isSurnameInputFocused = false"
          />
          @if (getRegisterForm.surname.errors && getRegisterForm.surname.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.surname.errors.required) {
                <div id="surname_mandatory">Prezime je obavezno!</div>
              }
              @if (getRegisterForm.surname.errors.pattern) {
                <div id="surname_validator">Unos nije validan!</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon': getRegisterForm.email.errors && getRegisterForm.email.touched,
              'is-valid-icon': getRegisterForm.email.valid && getRegisterForm.email.touched,
              'input-focus': isEmailInputFocused && !getRegisterForm.email.touched
            }"
          >
            <img src="{{ USERNAME }}" alt="" />
          </div>
          <input
            autoComplete="email"
            id="email"
            placeholder="Unesite e-mail"
            required
            formControlName="email"
            class="form-control"
            type="email"
            (input)="inputChanged($event)"
            [ngClass]="{
              'is-invalid': getRegisterForm.email.errors && getRegisterForm.email.touched
            }"
            [class.is-valid]="getRegisterForm.email.valid && getRegisterForm.email.touched"
            autocomplete="on"
            (input)="convertToLower($event.target)"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isEmailInputFocused = true"
            (blur)="isEmailInputFocused = false"
          />

          @if (getRegisterForm.email.errors && getRegisterForm.email.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.email.errors.required) {
                <div id="email_mandatory">E-mail je obavezan!</div>
              } @else if (getRegisterForm.email.errors.email || getRegisterForm.email.invalid) {
                <div id="email_validator">E-mail mora biti u odgovarajućem formatu!</div>
              } @else if (getRegisterForm.email.errors.invalidEmail) {
                <div>E-mail mora biti u odgovarajućem formatu!</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon':
                getRegisterForm.confirmEmail.errors && getRegisterForm.confirmEmail.touched,
              'is-valid-icon':
                getRegisterForm.confirmEmail.valid && getRegisterForm.confirmEmail.touched,
              'input-focus': isConfirmEmailInputFocused && !getRegisterForm.confirmEmail.touched
            }"
          >
            <img src="{{ USERNAME }}" alt="email icon" />
          </div>
          <input
            autoComplete="confirmEmail"
            id="confirmEmail"
            placeholder="Potvrdite e-mail"
            required
            formControlName="confirmEmail"
            class="form-control"
            type="email"
            (input)="inputChanged($event)"
            [ngClass]="{
              'is-invalid':
                getRegisterForm.confirmEmail.errors && getRegisterForm.confirmEmail.touched
            }"
            [class.is-valid]="
              getRegisterForm.confirmEmail.valid && getRegisterForm.confirmEmail.touched
            "
            (input)="convertToLower($event.target)"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isConfirmEmailInputFocused = true"
            (blur)="isConfirmEmailInputFocused = false"
          />
          @if (getRegisterForm.confirmEmail.errors && getRegisterForm.confirmEmail.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.confirmEmail.errors.required) {
                <div id="emailConfirm_mandatory">Potvrda email-a je obavezna!</div>
              } @else if (getRegisterForm.confirmEmail.errors.invalidEmail) {
                <div id="emailConfirm_validator">E-mail mora biti u odgovarajućem formatu!</div>
              } @else if (getRegisterForm.confirmEmail.errors.confirmEmailValidator) {
                <div id="emailConfirm_match">E-mail adrese se ne podudaraju!</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon':
                getRegisterForm.phoneNumber.errors && getRegisterForm.phoneNumber.touched,
              'is-valid-icon':
                getRegisterForm.phoneNumber.valid && getRegisterForm.phoneNumber.touched,
              'input-focus': isPhoneNumberInputFocused && !getRegisterForm.phoneNumber.touched
            }"
          >
            <img src="{{ PHONE }}" alt="email icon" />
          </div>
          <input
            autoComplete="phone"
            id="phone"
            placeholder="Unesite broj telefona"
            type="tel"
            autocomplete="on"
            formControlName="phoneNumber"
            class="form-control"
            required
            (input)="inputChanged($event)"
            [ngClass]="{
              'is-invalid':
                getRegisterForm.phoneNumber.errors && getRegisterForm.phoneNumber.touched
            }"
            [class.is-valid]="
              getRegisterForm.phoneNumber.valid && getRegisterForm.phoneNumber.touched
            "
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isPhoneNumberInputFocused = true"
            (blur)="isPhoneNumberInputFocused = false"
          />
          @if (getRegisterForm.phoneNumber.errors && getRegisterForm.phoneNumber.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.phoneNumber.errors.required) {
                <div id="phone_validator">Broj telefona je obavezan!</div>
              }
              @if (
                getRegisterForm.phoneNumber.errors.pattern ||
                getRegisterForm.phoneNumber.errors.maxlength ||
                getRegisterForm.phoneNumber.errors.minlength
              ) {
                <div id="phone_validateFormat">
                  Broj telefona mora biti u odgovarajućem formatu!
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon':
                getRegisterForm.password.errors && getRegisterForm.password.touched,
              'is-valid-icon': getRegisterForm.password.valid && getRegisterForm.password.touched,
              'input-focus': isPasswordInputFocused && !getRegisterForm.password.touched
            }"
          >
            <img src="{{ PASSWORD }}" alt="email icon" />
          </div>
          <input
            autoComplete="password"
            placeholder="Unesite lozinku"
            type="password"
            required
            autocomplete="on"
            class="form-control"
            [ngClass]="{
              'is-invalid': getRegisterForm.password.errors && getRegisterForm.password.touched
            }"
            formControlName="password"
            id="password"
            (input)="inputChanged($event)"
            [class.is-valid]="getRegisterForm.password.valid && getRegisterForm.password.touched"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isPasswordInputFocused = true"
            (blur)="isPasswordInputFocused = false"
          />

          @if (getRegisterForm.password.errors && getRegisterForm.password.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.password.errors.required) {
                <div>Lozinka je obavezna!</div>
              }
              @if (
                getRegisterForm.password.errors.minlength || getRegisterForm.password.errors.pattern
              ) {
                <div>
                  Lozinka mora imati najmanje 8 karaktera, bar jedno veliko slovo ili specijalni
                  karakter!
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon':
                getRegisterForm.confirmPassword.errors && getRegisterForm.confirmPassword.touched,
              'is-valid-icon':
                getRegisterForm.confirmPassword.valid && getRegisterForm.confirmPassword.touched,
              'input-focus': isConfirmInputFocused && !getRegisterForm.confirmPassword.touched
            }"
          >
            <img src="{{ PASSWORD }}" alt="email icon" />
          </div>
          <input
            placeholder="Potvrdite lozinku"
            type="password"
            required
            class="form-control"
            [ngClass]="{
              'is-invalid':
                getRegisterForm.confirmPassword.errors && getRegisterForm.confirmPassword.touched
            }"
            formControlName="confirmPassword"
            (input)="inputChanged($event)"
            [class.is-valid]="
              getRegisterForm.confirmPassword.valid && getRegisterForm.confirmPassword.touched
            "
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isConfirmInputFocused = true"
            (blur)="isConfirmInputFocused = false"
          />

          @if (getRegisterForm.confirmPassword.errors && getRegisterForm.confirmPassword.touched) {
            <div class="invalid-feedback">
              @if (getRegisterForm.confirmPassword.errors.required) {
                <div id="passwordConfirm_validator">Potvrda lozinke je obavezna!</div>
              }
              @if (
                getRegisterForm.confirmPassword.errors.minlength ||
                getRegisterForm.confirmPassword.errors.pattern
              ) {
                <div id="passwordLength_validator">
                  Potvrda lozinke mora imati najmanje 8 karaktera, bar jedno veliko slovo ili
                  specijalni karakter!
                </div>
              }
              @if (getRegisterForm.confirmPassword.errors.confirmPasswordValidator) {
                <div id="passwordMatch_validator">Lozinke se ne podudaraju!</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="field field-top">
        <div class="checkbox-container">
          <input type="checkbox" formControlName="termsAndConditions" id="termsAndConditions" />
          <label class="checkbox-label" for="termsAndConditions">
            Prihvatam
            <a href="javascript:void(0)" (click)="openTermsDialog()">uslove korišćenja</a> i
            <a href="javascript:void(0)" (click)="openPrivacyDialog()">politiku privatnosti</a
            ><span class="dot">.</span>
          </label>
        </div>
        @if (getRegisterForm.termsAndConditions.errors) {
          <div class="invalid-feedback">
            @if (getRegisterForm.termsAndConditions.errors.required) {
              <div id="termsAndConditions_validator">
                Prihvatite uslove korišćenja i politiku privatnosti!
              </div>
            }
          </div>
        }
      </div>
      <div class="field field-botom">
        <div class="checkbox-container">
          <input type="checkbox" formControlName="notMinor" id="notMinor" />
          <label class="checkbox-label" for="notMinor">Da, imam više od 18 godina.</label>
        </div>
        @if (getRegisterForm.notMinor.errors) {
          <div class="invalid-feedback">
            @if (getRegisterForm.notMinor.errors.required) {
              <div id="notMinor_validator">Potvrdi da si punoletan!</div>
            }
          </div>
        }
      </div>
      @if (registerError) {
        <div class="text-danger">
          {{ registerError }}
        </div>
      }
      <button
        class="button"
        type="submit"
        class="btn--orange"
        [disabled]="!registrationForm.valid || spinnerService.spinnerVisible"
      >
        Registruj se
        <app-button-spinner></app-button-spinner>
      </button>
      <div class="form__lower">
        <p class="form__lower-label">Već imaš nalog?</p>
        <a routerLink="/{{ LOGIN_ROUTE }}" class="login__link form__lower-link">Uloguj se</a>
      </div>
      <div class="divider">&nbsp;</div>
      <div><a class="about-app" routerLink="/{{ ABOUT_APP }}">O aplikaciji</a></div>
      <div class="divider">&nbsp;</div>
    </form>
  </div>
</div>
<app-terms-dialog></app-terms-dialog>
<app-privacy-dialog></app-privacy-dialog>
<div #turnstileContainer></div>
